
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { RsvpStatus } from '../hooks/useRsvpStatus';

interface RsvpStatusBadgeProps {
  status?: RsvpStatus;
}

export const RsvpStatusBadge: React.FC<RsvpStatusBadgeProps> = ({ status }) => {
  switch (status) {
    case 'accepted':
      return <Badge className="bg-green-100 text-green-800 hover:bg-green-100">Attending</Badge>;
    case 'declined':
      return <Badge className="bg-red-100 text-red-800 hover:bg-red-100">Not Attending</Badge>;
    case 'maybe':
      return <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">Maybe</Badge>;
    default:
      return <Badge className="bg-gray-100 text-gray-800 hover:bg-gray-100">Pending</Badge>;
  }
};
